import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function SocialProofSection() {
  const testimonials = [{
    quote: "I was skeptical — I've seen every real estate guru pitch. But this is different. No fluff, just the exact contracts and ZIP codes. I had my first unit cash-flowing in 19 days.",
    name: 'Robert M., 57',
    location: 'Tampa, FL',
    result: '$1,100/mo — 1 unit'
  }, {
    quote: "At my age, I can't afford to gamble. The Shadow Clause alone was worth 100x the price. My landlord actually thanked me for the arrangement.",
    name: 'David K., 62',
    location: 'Austin, TX',
    result: '$2,400/mo — 2 units'
  }, {
    quote: "I spent $4,000 on a real estate course last year and learned less than what's in this $47 blueprint. The 3-App Autopilot changed everything.",
    name: 'James T., 54',
    location: 'Orlando, FL',
    result: '$3,300/mo — 3 units'
  }];
  const stats = [{
    value: '2,400+',
    label: 'Downloads'
  }, {
    value: '$1.2M+',
    label: 'Monthly Revenue Generated'
  }, {
    value: '4.9/5',
    label: 'Average Rating'
  }];
  return <section className="w-full bg-[#0f1724] py-12 md:py-20 px-4 relative" data-id="element-187">
      {/* Gold Divider */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-[#c9a84c]" data-id="element-188"></div>

      <div className="max-w-6xl mx-auto" data-id="element-189">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-2xl md:text-4xl text-[#c9a84c] text-center mb-8 md:mb-16" data-id="element-190">
          What Shadow Providers Are Saying
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 mb-10 md:mb-16" data-id="element-191">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-[#1a2332] border border-[#c9a84c]/10 rounded-xl p-5 md:p-8 flex flex-col h-full relative" data-id="element-192">
              <div className="flex gap-1 mb-4" data-id="element-193">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#c9a84c] text-[#c9a84c]" data-id="element-194" />)}
              </div>
              <p className="text-[#f5f0e8]/90 italic mb-4 md:mb-6 flex-grow leading-relaxed text-sm md:text-base" data-id="element-195">
                "{testimonial.quote}"
              </p>
              <div className="mt-auto border-t border-[#c9a84c]/10 pt-4" data-id="element-196">
                <p className="text-white font-bold" data-id="element-197">{testimonial.name}</p>
                <p className="text-[#f5f0e8]/60 text-sm mb-2" data-id="element-198">
                  {testimonial.location}
                </p>
                <p className="text-[#c9a84c] font-bold text-sm bg-[#c9a84c]/10 inline-block px-2 py-1 rounded" data-id="element-199">
                  {testimonial.result}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Stats Bar */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="flex flex-row justify-center items-center gap-6 md:gap-16 border-t border-[#c9a84c]/20 pt-8 md:pt-12" data-id="element-200">
          {stats.map((stat, index) => <div key={index} className="text-center flex flex-col items-center" data-id="element-201">
              <span className="text-xl md:text-4xl font-bold text-[#c9a84c] mb-1" data-id="element-202">
                {stat.value}
              </span>
              <span className="text-[#f5f0e8]/60 text-[10px] md:text-sm uppercase tracking-wider" data-id="element-203">
                {stat.label}
              </span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}